import { render, staticRenderFns } from "./SvgTitle.vue?vue&type=template&id=7c4bb19a&scoped=true"
import script from "./SvgTitle.vue?vue&type=script&lang=ts"
export * from "./SvgTitle.vue?vue&type=script&lang=ts"
import style0 from "./SvgTitle.vue?vue&type=style&index=0&id=7c4bb19a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4bb19a",
  null
  
)

export default component.exports